<div class="modal-overlay">
  <div class="modal-dialog">
    <div class="modal-content">
      <button class="close-btn p-1 rounded-circle border" (click)="closeModal()">×</button>
      <div class="inner_wrapper w-100 d-flex justify-content-center align-items-center flex-column">
        <img [src]="extra_data.type == 1 ? '/assets/images/icons/consumer-banner.png' : '/assets/images/icons/commercial-banner.png'" alt="">
        <h4 class="m-0 pt-1 pb-2 heading">Collect from {{extra_data.type == 1 ? 'Individuals' : 'Businesses'}}</h4>
        <p class="subheading m-0">Enable {{extra_data.type == 1 ? 'Consumer Debts to track overdue invoices from individual customers.' : 'Commercial Debt to recover outstanding balances from business clients.'}} </p>
        <div class="border-top mxw-70 small-divider"></div>
        <div class="text-body">
            <h4 class="m-0 pb-2" [ngClass]="extra_data.type == 1 ? 'consumer' : 'commercial' ">How {{extra_data.type == 1 ? 'Consumer' : 'Commercial'}} Debt Works</h4>
            <p class="m-0 pb-4" [ngClass]="extra_data.type == 1 ? 'consumer' : 'commercial' ">{{extra_data.type == 1 ? 'Consumer debt recovery helps you collect balances from individual customers.' : 'Commercial debt recovery helps you collect balances from businesses, not individuals.'}}</p>
        </div>
        <div class="px-3 mb-3 w-100">
            <div class="p-2 radius-8 border w-100">
            <ol class="ps-4 m-0">
                <li>{{extra_data.type == 1 ? 'Add contact and debt details' : 'Add company and contact details'}}</li>
                <li>Upload invoices or bulk data files</li>
                <li>Automated outreach starts instantly</li>
                <li>Track recovery progress in your dashboard</li>
            </ol>
        </div>
        <div class="d-flex justify-content-center pt-4">
            <button class="btn p-3" (click)="updatedebttype(extra_data.type)" [ngClass]="extra_data.type == 1 ? 'btn-consumer' : 'btn-commercial'">{{extra_data.type == 1 ? 'Enable Consumer Debt' : 'Enable Commercial Debt'}}</button>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>
 